export default __webpack_public_path__ + "static/media/lightning-bolt.855567ef.svg";